import { render, staticRenderFns } from "./ViewInventorySpecimensById.vue?vue&type=template&id=621c4bae&scoped=true"
import script from "./ViewInventorySpecimensById.vue?vue&type=script&lang=js"
export * from "./ViewInventorySpecimensById.vue?vue&type=script&lang=js"
import style0 from "./ViewInventorySpecimensById.vue?vue&type=style&index=0&id=621c4bae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621c4bae",
  null
  
)

export default component.exports